import Logo from '@avanta/shared/assets/avanta-logo.svg';
import { cn } from '@avanta/shared/utils/cn';
import { Link, NavLink } from 'react-router';
import { ROUTES } from 'constants/routes';
import { useNavActions, useScrollCompactNavBar } from '../hooks';
import { DesktopActions } from './DesktopActions';

const DESKTOP_NAV_ROW_CLASS = 'mx-auto flex w-full max-w-7xl items-center px-15 max-am-3xl:hidden';

export const DesktopNav = (): React.ReactElement => {
  const isCompact = useScrollCompactNavBar();
  const { primaryNavRoutes, primaryNavLinkLabel } = useNavActions();
  const rowHeightClass = isCompact ? 'h-12' : 'h-16';
  const logoHeightClass = isCompact ? 'h-8' : 'h-9';

  return (
    <div className={cn(DESKTOP_NAV_ROW_CLASS, rowHeightClass)}>
      <div className="flex min-w-0 flex-1 items-center gap-10">
        <Link to={ROUTES.HOME} className="flex items-center max-am-xl:hidden">
          <img src={Logo} alt="Avanta Mynd Logo" className={cn(logoHeightClass, 'w-auto')} />
        </Link>
        <nav className="flex gap-5">
          {primaryNavRoutes.map(route => (
            <NavLink
              key={route.href}
              to={route.href}
              end
              className={({ isActive }) =>
                cn(
                  'relative inline-flex items-center justify-center',
                  'text-sm font-medium text-denim-500 transition-colors hover:text-teal-500',
                  'before:pointer-events-none before:absolute before:inset-x-0 before:top-0',
                  'before:h-1 before:bg-transparent before:transition-colors before:content-[""]',
                  rowHeightClass,
                  isActive
                    ? 'text-teal-500 before:bg-teal-500'
                    : 'text-denim-500 hover:text-teal-500'
                )
              }
            >
              {primaryNavLinkLabel(route)}
            </NavLink>
          ))}
        </nav>
      </div>
      <DesktopActions />
    </div>
  );
};
